import { Form, Checkbox, Link, Button, Space, Message, Input } from "@arco-design/web-react";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import logoradioa from "@/assets/iconimage/radioa.png";
import logoradiob from "@/assets/iconimage/radiob.png";
import eye_open from "@/assets/iconimage/eye_open.png";
import CryptoJS from "crypto-js";
import eye_close from "@/assets/iconimage/eye_close.png";
import "./style/style.less";
const FormItem = Form.Item;
import { observer, inject } from "mobx-react";
import Cookies from "js-cookie";
import { SecureStringGenerator } from "@/utils";
import appStore from "@/stores/appStore";
import LoginAccountInput from "@/components/LoginAccountInput";

const Accountlogin = (props: any) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const formref = useRef(form);
  const [radioopp, setradioopp] = useState(0);
  const [loading, setLoading] = useState(false);
  const [checkdata, setcheckdata] = useState(false);
  const { login } = props;
  const location = useLocation();
  const [urlstate, setstate] = useState(null);
  const [passVisibility, setPassVisibility] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  // 状态：是否在 electron 环境中 (undefined表示未检测，false表示非electron，true表示electron)
  const [isElectron, setIsElectron] = useState<boolean | undefined>(undefined);

  // 检测是否在 electron 环境中
  useEffect(() => {
    const checkIsElectron = () => {
      // 确保总是返回布尔值
      return !!(window && window.electron);
    };
    setIsElectron(checkIsElectron());
  }, []);

  // 页面初始化时，在非electron环境下自动填充账号密码
  useEffect(() => {
    // 只有当isElectron明确为false时才执行自动填充
    if (isElectron === false) {
      try {
        const encryptedData = Cookies.get("Logindata");
        if (encryptedData) {
          const bytes = CryptoJS.AES.decrypt(
            encryptedData,
            SecureStringGenerator.generate(16)
          );
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          if (decrypted) {
            const data = JSON.parse(decrypted);
            // 确保是数组或转换为数组
            const logins = Array.isArray(data) ? data : [data];
            if (logins.length > 0 && logins[0]) {
              // 设置账号和密码
              const savedLogin = logins[0];
              setPhoneNumber(savedLogin.phone_number || '');
              formref.current.setFieldValue("phone_number", savedLogin.phone_number || '');
              formref.current.setFieldValue("password", savedLogin.password || '');
            }
          }
        }
      } catch (error) {
        console.error("解析存储的登录数据时出错:", error);
      }
    }
  }, [isElectron]);

  useEffect(() => {
    try {
      const code = location.search.split("=")[1];
      setstate(code);
    } catch (e) {}
  }, [location]);

  function validatePassword(value, callback) {
    if (!value) {
      callback(<div>密码不能为空</div>);
    } else if (!/^.{6,}$/.test(value)) {
      callback(
        <div>请输入6-12个字符，支持数字、大小写字母和符号至少包含一种</div>
      );
    } else {
      callback();
    }
  }

  async function onSubmitClick(datalist) {
    // 是odm贴牌的话，不需要协议
    if (!radioopp && !appStore.isOdm) {
      Message.info("请勾选用户协议");
    } else {
      setLoading(true);
      await login.Accc_use_login(datalist);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (login.isSuccess) {
      if (checkdata) {
        const password = formref.current.getFieldValue("password");
        const phone_number = formref.current.getFieldValue("phone_number");
        // 只保留日期部分（年-月-日）
        const loginDate = new Date();
        const dateString = `${loginDate.getFullYear()}-${String(loginDate.getMonth() + 1).padStart(2, '0')}-${String(loginDate.getDate()).padStart(2, '0')}`;
        const newLoginData = {
          phone_number: phone_number,
          password: password,
          loginTime: dateString
        };
        
        // 获取现有存储的登录数据
        let savedLogins = [];
        if (Cookies.get("Logindata")) {
          try {
            const encryptedData = Cookies.get("Logindata");
            const bytes = CryptoJS.AES.decrypt(
              encryptedData,
              SecureStringGenerator.generate(16)
            );
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            if (decrypted) {
              const data = JSON.parse(decrypted);
              // 检查是否为数组，如果不是则转换为数组
              savedLogins = Array.isArray(data) ? data : [data];
            }
          } catch (error) {
            console.error("解析存储的登录数据时出错:", error);
            savedLogins = [];
          }
        }
        
        // 移除已存在的相同账号
        savedLogins = savedLogins.filter(item => item.phone_number !== phone_number);
        
        // 添加新账号到开头
        savedLogins.unshift(newLoginData);
        
        // 根据环境决定存储账号数量
        // 确保只有在环境检测完成后才执行存储操作
        const maxAccounts = isElectron === true ? 10 : 1;
        if (savedLogins.length > maxAccounts) {
          savedLogins = savedLogins.slice(0, maxAccounts);
        }
        
        // 存储更新后的登录数据
        Cookies.set(
          "Logindata",
          CryptoJS.AES.encrypt(
            JSON.stringify(savedLogins),
            SecureStringGenerator.generate(16)
          ).toString(),
          {
            expires: 7,
          }
        );
      } else {
        // 不记住密码时，不清除所有存储的账号，只清除当前账号的选中状态
      }
      setTimeout(() => {
        const searchParams = new URLSearchParams(location.search);
        const next = searchParams.get("next") || "/";
        navigate(next, { replace: true });
        login.isSuccess = false;
      }, 600);
    }
  }, [login.isSuccess]);

  const actvieclike = () => {
    props.activepassword();
  };

  const validatePhoneNumber = (value, callback) => {
    // const regex = /^1(3|4|5|6|7|8|9)\d{9}$/
    if (!value) {
      callback(<div>请输入正确的用户名</div>);
    } else {
      callback();
    }
  };
  
  // 处理账号输入变化
  const handlePhoneNumberChange = (value: string) => {
    setPhoneNumber(value);
    formref?.current.setFieldValue("phone_number", value);
  };
  
  // 自动填充密码
  const handleAutoFillPassword = (password: string) => {
    formref?.current.setFieldValue("password", password);
    setcheckdata(true);
  };

  return (
    <div>
      <Form ref={formref} autoComplete="off" className="form-cottop">
        <div style={{ position: 'relative' }}>
          <FormItem
            field="phone_number"
            rules={[
              { validator: validatePhoneNumber, validateTrigger: "onBlur" },
            ]}
          >
            <LoginAccountInput
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              formRef={formref}
              autoFillPassword={handleAutoFillPassword}
            />
          </FormItem>
        </div>
        <FormItem
          field="password"
          rules={[{ validator: validatePassword, validateTrigger: ["onBlur"] }]}
        >
          <Input.Password
            defaultValue="password"
            autoComplete="current-password"
            placeholder="请输入密码"
            visibility={passVisibility}
            onVisibilityChange={setPassVisibility}
            suffix={
              <img
                src={passVisibility ? eye_open : eye_close}
                style={{ cursor: "pointer" }}
                width={12}
              />
            }
          />
        </FormItem>
        <Space direction="vertical">
          <div id="login-actions">
            {/* <Checkbox checked={rememberPassword} onChange={setRememberPassword}>
              记住密码
            </Checkbox> */}
            <Checkbox
              // value={checkdata}
              // defaultValue={checkdata}
              // defaultChecked={checkdata}
              checked={checkdata}
              onChange={() => {
                setcheckdata(!checkdata);
              }}
            >
              记住密码
            </Checkbox>
            <Link
              onClick={() => {
                actvieclike();
              }}
            >
              忘记密码
            </Link>
          </div>
          <Button
            type="primary"
            long
            loading={loading}
            onClick={async () => {
              if (formref.current) {
                try {
                  await formref.current.validate();
                  const password = formref.current.getFieldValue("password");
                  const phone_number =
                    formref.current.getFieldValue("phone_number");
                  onSubmitClick({ phone_number, password });
                } catch (_) {
                  // console.error(_);
                }
              }
            }}
            className="styleInputbutton"
          >
            登录
          </Button>
          {!appStore.isOdm ? (
            <div className="radiobody" style={{ cursor: "pointer" }}>
              {radioopp === 0 ? (
                <div
                  className="logi_form_titlerekeli"
                  onClick={() => {
                    setradioopp(1);
                  }}
                >
                  <p className="ardioactiveer"></p>
                  <span>我已阅读并同意</span>
                </div>
              ) : (
                <div
                  className="logi_form_titlerekeli"
                  onClick={() => {
                    setradioopp(0);
                  }}
                >
                  <img src={logoradiob} alt="" className="ardioactive" />
                  <span>我已阅读并同意</span>
                </div>
              )}

              <span className="login-form-itemhover">
                <span
                  style={{
                    color: "#165dff",
                  }}
                  onClick={() => {
                    window.open("/policy.html", "policy");
                  }}
                >
                  平台隐私政策
                </span>
                &nbsp; 与&nbsp;
                <span
                  style={{
                    color: "#165dff",
                  }}
                  onClick={() => {
                    window.open("/agreement.html", "agreement");
                  }}
                >
                  平台用户服务协议
                </span>
              </span>
            </div>
          ) : null}
          {/* <div>
            <p>17627921976</p>
            <p>@QQQwww123</p>
          </div> */}
        </Space>
      </Form>
    </div>
  );
};
export default inject("login")(observer(Accountlogin));
